import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import CookieBanner from '@/components/feature/CookieBanner';
import ScrollToTop from '@/components/feature/ScrollToTop';
import PasswordGate from '@/components/feature/PasswordGate';

function App() {
  return (
    <PasswordGate>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
        <CookieBanner />
      </BrowserRouter>
    </PasswordGate>
  );
}

export default App;
